import React from 'react';
import { observer } from 'mobx-react';
import Tooltip from 'components/Tooltip';

export type DisabledWrapperProps = {
  children: React.ReactElement;
  disabled?: boolean;
  tooltip?: string;
};

export const DisabledWrapper: React.FC<
  Omit<DisabledWrapperProps, 'style' | 'tooltip'>
> = ({ disabled = false, children }) => {
  return (
    <div
      className={disabled ? 'cursor-not-allowed opacity-30 select-none' : ''}
    >
      <div className={`${disabled ? 'pointer-events-none' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export const DisabledWrapperWithTooltip = observer(
  ({
    disabled,
    children,
    tooltip = 'Editor rights are required. Please speak to your Workspace Admin.',
  }: DisabledWrapperProps) => {
    return (
      <>
        <Tooltip delayShow={500} place='bottom' id='disableReason' />
        {disabled ? (
          <div
            data-tip={tooltip}
            data-for='disableReason'
            data-testid='SystemDisableReason'
            className='cursor-not-allowed opacity-30 select-none'
          >
            <div className='pointer-events-none '>{children}</div>
          </div>
        ) : (
          children
        )}
      </>
    );
  },
);
